//#region src/Password/password-utils.ts
var PASSWORD_MIN_LENGTH = 8;
var PASSWORD_BETTER_LENGTH = 10;
var getPasswordStrength = (password = "") => {
	const hasMinLength = password.length >= 8;
	const hasBetterLength = password.length >= PASSWORD_BETTER_LENGTH;
	const minLengthScore = hasMinLength ? 1 : 0;
	const betterLengthScore = hasBetterLength ? 1 : 0;
	const hasNonAlphas = Boolean(password.match(/[^a-zA-Z]/));
	const hasMixedCase = Boolean(password.match(/[a-z]/)) && Boolean(password.match(/[A-Z]/));
	const nonAlphaScore = hasNonAlphas ? 1 : 0;
	const mixedCaseScore = hasMixedCase ? 1 : 0;
	const intermediateScore = 8 * minLengthScore + 4 * nonAlphaScore + 2 * mixedCaseScore + betterLengthScore;
	let scaledScore = 0;
	if (intermediateScore >= 15) scaledScore = 4;
	else if (intermediateScore >= 14) scaledScore = 3;
	else if (intermediateScore >= 12) scaledScore = 2;
	else if (intermediateScore >= 8) scaledScore = 1;
	return {
		hasMinLength,
		hasMixedCase,
		hasNonAlphas,
		scaledScore
	};
};
//#endregion
export { getPasswordStrength as n, PASSWORD_MIN_LENGTH as t };

//# sourceMappingURL=Password-ooRSIQIs.js.map